export const lineList = [
  {
    lineProgress: '25%',
    minScore: '16',
    maxScore: '18.5',
    textProgress: '7.5%',
    label: `偏瘦<br>＜18.5`
  },
  {
    lineProgress: '50%',
    minScore: '18.5',
    maxScore: '24',
    textProgress: '30.5%',
    label: `正常<br>18.5-24`
  },
  {
    lineProgress: '75%',
    minScore: '24',
    maxScore: '28',
    textProgress: '57.5%',
    label: `超重<br>24-28`
  },
  {
    lineProgress: '100%',
    minScore: '28',
    maxScore: '35',
    textProgress: '82.5%',
    label: `肥胖<br>>=28`
  }
]
